import { render, staticRenderFns } from "./CreateSimulation.vue?vue&type=template&id=61058b7c&"
import script from "./CreateSimulation.vue?vue&type=script&lang=ts&"
export * from "./CreateSimulation.vue?vue&type=script&lang=ts&"
import style0 from "./CreateSimulation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports